// Helper functions for CalendarDate conversion (UCalendar uses @internationalized/date)
import { CalendarDate, type DateValue } from '@internationalized/date'

// Input: Date -> Output: CalendarDate
export const dateToCalendarDate = (date: Date | null): CalendarDate | null => {
  if (!date) return null
  // Use local timezone to get the correct date
  return new CalendarDate(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate()
  )
}

// Input: CalendarDate -> Output: Date
export const calendarDateToDate = (calendarDate: CalendarDate | null): Date | null => {
  if (!calendarDate) return null
  // Create a new Date object using the calendar date values in local timezone
  return new Date(calendarDate.year, calendarDate.month - 1, calendarDate.day)
}

// Check if a DateValue matches any date in markers array (hotelDispo)
// hotelDispo is an array of objects like [{ date: Date, type: string, color: string }, ...]
export const isDateMarked = (calendarDate: DateValue, markers: Array<{ date: Date }> | null): boolean => {
  if (!markers || markers.length === 0) return false
  const dateStr = `${calendarDate.year}-${String(calendarDate.month).padStart(2, '0')}-${String(calendarDate.day).padStart(2, '0')}`
  return markers.some(marker => {
    const markerDate = marker.date instanceof Date ? marker.date : new Date(marker.date)
    const markerStr = `${markerDate.getFullYear()}-${String(markerDate.getMonth() + 1).padStart(2, '0')}-${String(markerDate.getDate()).padStart(2, '0')}`
    return dateStr === markerStr
  })
}

